import Vue from 'vue'
import axios from 'axios'
import { state } from './store/state';

export default axios.create({
    baseURL: state.api_url,
    headers: {
        'Authorization': state.api_token
    },
    withCredentials: false
})


// WEBPACK FOOTER //
// ./src/ajax.js